export const DEFAULT_MESSAGE = 'Loading...';
export const TestID = 'ComboBox.LoadingResultsTestID';
